import update from 'immutability-helper';
import PDFPageEditorOptInPanelEnum from './PDFPageEditorOptInPanelConstants';

const initialState = {
  pages: [],
  pdfFile: [],
};

const PDFPageEditorOptInPanelReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case PDFPageEditorOptInPanelEnum.PDF_PAGE_EDITOR_OPT_IN_PANEL_SET_PAGES_FROM_FILE:
      return update(state, {
        pages: { $unshift: action.pages },
      });
    default:
      return state;
  }
};

export default PDFPageEditorOptInPanelReducer;



// WEBPACK FOOTER //
// ./src-react/PDFPageEditorOptInPanel/PDFPageEditorOptInPanelReducer.jsx